import { set } from 'lodash';
import { useCallback, useState } from 'react';
import { useLazyGetCallSessionHistoriesQuery } from 'services';
import { FindAllCallSessionDto } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useLazyOmniCallSessionHistoriesList() {
  const [trigger, { data: dataResponse, isLoading, isFetching, originalArgs }] = useLazyGetCallSessionHistoriesQuery();
  const [loading, setLoading] = useState(false);
  const { rows, count } = dataResponse?.data || {};
  const hasMore = Boolean(rows && count && rows.length < count);

  const handleLoadMore = useCallback(() => {
    if (hasMore)
      trigger({
        ...originalArgs,
        limit: pageSize,
        skip: rows?.length
      });
  }, [hasMore, originalArgs, rows]);

  const fetchData = useCallback((value?: Partial<FindAllCallSessionDto>) => {
    setLoading(true);
    trigger({
      skip: 0,
      limit: pageSize,
      ...originalArgs,
      ...value
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  return {
    data: rows || [],
    count: count || 0,
    isLoading: isLoading || loading,
    hasMore,
    fetchData,
    handleLoadMore,
    isFetching: isFetching,
    originalArgs
  };
}
